import {combineReducers} from 'redux';

import {cellsListsReducer} from './cellsLists/cellsListsReducer';
import {commentComposerReducer} from './commentComposer/commentComposerReducer';
import {recentCommunicationsReducer} from './recentCommunications/recentCommunicationsReducer';

/*
 * Reducer.
 */

export const metadataReducer = combineReducers({
  cellsLists: cellsListsReducer,
  commentComposer: commentComposerReducer,
  recentCommunications: recentCommunicationsReducer,
});
